const STATS = [
  { stat: '15', label: 'attack categories' },
  { stat: '20', label: 'turns per run' },
  { stat: '14', label: 'bugs found and fixed' },
]

/** Quick-facts row for "When Langy Went Off-Script": same number treatment as the customer-story results rail. */
export function OffScriptStats() {
  return (
    <div className="not-prose my-8 grid grid-cols-3 gap-x-6 gap-y-5 rounded-2xl border border-ink-100 bg-paper-soft/40 p-6">
      {STATS.map((s) => (
        <div key={s.label}>
          <div className="display text-[28px] leading-[1] text-ink-900 md:text-[32px]">{s.stat}</div>
          <div className="mt-1.5 text-[12.5px] leading-[1.4] text-ink-500">{s.label}</div>
        </div>
      ))}
    </div>
  )
}
